import { RequirementForm } from "./RequirementForm";

const AddRequirement = () => {
  return <RequirementForm edit={false} />;
};

export { AddRequirement };
